import { formatScaled, parseScaled } from "./decimal";

export function parseBRL(input: string): number {
  return parseScaled(input, 2, "invalid_money");
}

export function formatBRL(cents: number): string {
  const s = formatScaled(cents, 2, 2);
  return s.startsWith("-") ? `-R$ ${s.slice(1)}` : `R$ ${s}`;
}
